module.exports = __webpack_public_path__ + "static/media/Tom Morrison Headshot.0716cad0.jpeg";